import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';
import { ncFilePerformanceConfig } from '@v2/pages/job/navigation/config';

const JobDetailsNCFilePerformanceStack = createStackNavigator();

const JobDetailsNCFilePerformanceNavigator = () => {
  return (
    <JobDetailsNCFilePerformanceStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {ncFilePerformanceConfig.map(({ Component, name }) => (
        <JobDetailsNCFilePerformanceStack.Screen key={name} name={name} component={Component} />
      ))}
    </JobDetailsNCFilePerformanceStack.Navigator>
  );
};

export { JobDetailsNCFilePerformanceNavigator };
